import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';
import WaiscenLogoMark from 'assets/waiscen/logoMark.svg?react';

const waiscenBaseUrl = `${envConfig('b2BucketUrl')}/homeSecurity/waiscen`;

export const defaultAssets: TPartnerAssets = {
  logo: `${waiscenBaseUrl}/logo.svg`,
  loginIllustration: `${waiscenBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${waiscenBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${waiscenBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${waiscenBaseUrl}/attention.svg`,
  basicAlertsIcon: `${waiscenBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${waiscenBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${waiscenBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${waiscenBaseUrl}/decriptiveAIAlertsIcon.svg`,
  firmwareVersionIcon: `${waiscenBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${waiscenBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${waiscenBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${waiscenBaseUrl}/location.svg`,
  logoContrastIcon: `${waiscenBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${waiscenBaseUrl}/logoWhite.svg`,
  logoMarkIcon: WaiscenLogoMark,
  maxCameraLimitReachedIcon: `${waiscenBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${waiscenBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${waiscenBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${waiscenBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${waiscenBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${waiscenBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${waiscenBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${waiscenBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${waiscenBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${waiscenBaseUrl}/professionMonitoringIcons.svg`,
  sampleCreditCardIcon: `${waiscenBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${waiscenBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${waiscenBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${waiscenBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${waiscenBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${waiscenBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${waiscenBaseUrl}/motionAlerts.svg`,
  snapshotIcon: `${waiscenBaseUrl}/snapshotIcon.svg`,
  liveViewIcon: `${waiscenBaseUrl}/liveViewIcon.svg`,
  dataIcon: `${waiscenBaseUrl}/dataIcon.svg`,
  noDataIcon: `${waiscenBaseUrl}/noDataIcon.svg`,
  autoDataRechargeDisabled: `${waiscenBaseUrl}/autoDataRechargeDisabled.svg`,
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${waiscenBaseUrl}/basicMotionAlerts-es.png`,
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
